@if ($tags().length > 0) {
    <sh-tag-list
        [tags]="$tags()"
        [tagIdPrefix]="face().Id"
        [editable]="editable()"
        [disabled]="disabled()"
        [singleTag]="true"
        [labels]="labels"
        [editWarning]="true"
        (onTagsUpdate)="onTagsEdit($event)"
        (onTagRemove)="onTagRemove()"
        (onTagFocus)="onTagFocus($event)"
        (mouseenter)="onMouseenter(face().Id)"
        (mouseleave)="onMouseleave()"
        (shClickOutside)="onTagFocus(null)"
    >
    </sh-tag-list>
} @else {
    <p [id]="face().Id + '-0'" (mouseenter)="onMouseenter(face().Id)" (mouseleave)="onMouseleave()">-</p>
}
